import { throttle } from 'lodash';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Link, RouteComponentProps } from 'react-router-dom';

import logo from 'assets/images/website-logo.png';
import EmailForm from 'components/global/application/EmailForm';
import RoundedCallout from 'components/global/application/nav/RoundedCallout';
import Nav from 'containers/global/application/Nav/Nav';
import TextSearch from 'containers/global/form/TextSearch';
import Product from 'types/shopify/Product';

import './Header.sass';

export interface StateProps {
    isMobile: boolean;
    isHeaderShowing: boolean;  // Keep track of this so dispatches only occur when needed
    menuProducts: Product[];
    menuProductsLoading: boolean;
}

export interface DispatchProps {
    setHeaderShowing(showing: boolean): void;
    getAccessoriesMenu(): void;
    loadShopifyProductsAndCart(): void;
}

type CombinedProps = StateProps & DispatchProps & RouteComponentProps<any>;

interface IState {
    showNav: boolean;
    showNewsLetterSignup: boolean;
    showTextSearch: boolean;
}

class ApplicationHeader extends React.Component<CombinedProps, IState> {
    private containerDiv: HTMLDivElement;
    constructor(props: CombinedProps) {
        super(props);

        this.state = {
            showNav: false,
            showNewsLetterSignup: false,
            showTextSearch: false
        };

        this.navShowToggle = this.navShowToggle.bind(this);
    }

    public componentDidMount() {
        this.props.loadShopifyProductsAndCart();
        // this.props.getAccessoriesMenu();
        this.trackScrolling();
        window.addEventListener('scroll', throttle(this.trackScrolling, 100));
    }

    public navShowToggle = () => {
        this.setState({ showNav: !this.state.showNav });
    }

    public toggleTextSearch = () => {
        this.setState({ showTextSearch: !this.state.showTextSearch });
    }

    public newsLetterShowToggle = () => {
        this.setState({ showNewsLetterSignup: !this.state.showNewsLetterSignup });
    }

    public render()  {
        return this.props.isMobile ? this.renderMobile() : this.renderDesktop();
    }

    public renderMobile = () => {
        return (
            <div ref={div => this.containerDiv = div} className="App-header-container-mobile">
                <EmailForm isOpen={this.state.showNewsLetterSignup} onRequestClose={this.newsLetterShowToggle} isMobile={true} />
                <Nav
                    isOpen={this.state.showNav}
                    closeHandler={this.navShowToggle}
                    menuProductsLoading={this.props.menuProductsLoading}
                    menuProducts={this.props.menuProducts}
                />
                <div className="row App-header">
                    <div className="col-2"><FontAwesome name="bars" className="Icon" onClick={this.navShowToggle}/></div>
                    <div className="col-8">
                        <a href="/"><img className="logo img-responsive" src={logo} /></a>
                        <h1>THE WORLD'S PREMIERE VINTAGE GUITAR STORE</h1>
                    </div>
                    <div className="col-2">
                        <FontAwesome
                            name="search"
                            className="Icon"
                            onClick={this.toggleTextSearch}
                        />
                    </div>
                </div>
                    <div className="d-flex flex-row">
                        <RoundedCallout
                            text="615-256-2033"
                            link="tel:615-256-2033"
                            icon="phone"
                            className="w-100 my-1 mx-1"
                        />
                        <RoundedCallout
                            text="New Inventory Updates"
                            icon="envelope-open-o"
                            className="w-100 my-1 mx-1"
                            onClick={this.newsLetterShowToggle}
                        />
                    </div>
                    {this.state.showTextSearch ? <TextSearch /> : ''}
           </div>
        );
    }

    public renderDesktop = () => {
        return(
            <div ref={div => this.containerDiv = div} className="App-header-container">
                <EmailForm isOpen={this.state.showNewsLetterSignup} onRequestClose={this.newsLetterShowToggle} isMobile={false} />
                <div className="row App-header">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <Link to="/">
                                    <img className="logo img-responsive" src={logo} />
                                    <h1>THE WORLD'S PREMIERE VINTAGE GUITAR STORE</h1>
                                </Link>
                            </div>
                            <div className="col-4">
                                <div className="row no-gutters">
                                    <RoundedCallout
                                        text="615-256-2033"
                                        link="tel:615-256-2033"
                                        icon="phone"
                                        className="w-100 ms"
                                    />
                                    <RoundedCallout
                                        text="New Inventory Updates"
                                        icon="envelope-open-o"
                                        className="w-100 ms"
                                        onClick={this.newsLetterShowToggle}
                                    />
                                    <TextSearch />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Nav
                    isOpen={this.state.showNav}
                    closeHandler={this.navShowToggle}
                    menuProductsLoading={this.props.menuProductsLoading}
                    menuProducts={this.props.menuProducts}
                />
            </div>
        );
    }

    private trackScrolling = () => {
        const { isHeaderShowing, setHeaderShowing } = this.props;
        // true when header is showing
        const newHeaderShowingState = this.containerDiv.getBoundingClientRect().bottom >= 0;
        if (newHeaderShowingState !== isHeaderShowing) setHeaderShowing(newHeaderShowingState);
    }
}

export default ApplicationHeader;



// WEBPACK FOOTER //
// ./src/components/global/application/Header.tsx